import ProtectedLayout from 'layouts/ProtectedLayout';
import AboutPage from 'pages/app/About';
import EntryPointPage from 'pages/app/EntryPoint';
import LoginPage from 'pages/auth/Login';
import NotFoundPage from 'pages/NotFound';
import { createBrowserRouter } from 'react-router-dom';
import AuthGuard from 'components/AuthGuard';
import MasterQuestionPage from 'pages/app/LIA/Master Question';
import AddMasterQuestion from 'pages/app/LIA/Master Question/Add';
import EditMasterQuestion from 'pages/app/LIA/Master Question/Edit';
import MasterGroupPage from 'pages/app/LIA/Master Group';
import AddMasterGroupPage from 'pages/app/LIA/Master Group/Add';
import EditMasterGroupPage from 'pages/app/LIA/Master Group/Edit';
import AddAssessmentSchedulePage from 'pages/app/LIA/AssessmentSchedules/Add';
import LIARoutes from './lia';
import YearlyCalendarRoutes from './yearlyCalendar';
import LCMSRoutes from './lcms';
import DACUMRoutes from './dacum';
import AssessmentSchedulePage from 'pages/app/LIA/AssessmentSchedules';
import PublicAssessmentSchedulesPage from 'modules/internal/assessmentSchedules';
import PublicAssessmentDetailPage from 'modules/internal/assessmentSchedules/Detail';
import ExternalAssessmentDetailPage from 'modules/external/assessmentSchedules/Detail';
import SMEAssessmentDetailPage from 'modules/internal/assessmentSchedules/SMEDetail';
import PublicRoutes from './public';

const routes = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <ProtectedLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <EntryPointPage />
      },
      {
        path: '/about',
        element: <AboutPage />
      },

      {
        path: '/master-question',
        element: <MasterQuestionPage />
      },
      {
        path: '/master-question/add',
        element: <AddMasterQuestion />
      },
      {
        path: '/master-question/edit',
        element: <EditMasterQuestion />
      },
      {
        path: '/master-group',
        element: <MasterGroupPage />
      },
      {
        path: '/master-group/add',
        element: <AddMasterGroupPage />
      },
      {
        path: '/master-group/edit',
        element: <EditMasterGroupPage />
      },
      {
        path: '/assessment-schedule',
        element: <AssessmentSchedulePage />
      },
      {
        path: '/assessment-schedule/add',
        element: <AddAssessmentSchedulePage />
      },
      ...DACUMRoutes,
      ...LIARoutes,
      ...LCMSRoutes,
      ...YearlyCalendarRoutes
    ]
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: 'public/assessment-schedules',
    element: <PublicAssessmentSchedulesPage />
  },
  {
    path: 'public/assessment-schedules/detail',
    element: <PublicAssessmentDetailPage />
  },
  {
    path: '/public/external/assessment-schedule/detail',
    element: <ExternalAssessmentDetailPage />
  },
  {
    path: '/public/sme/assessment-schedules/detail',
    element: <SMEAssessmentDetailPage />
  },
  ...PublicRoutes,
  {
    path: '*',
    element: <NotFoundPage />
  }
]);

export default routes;
